module.exports = __webpack_public_path__ + "static/media/instagram_icon.7c71ed05.png";